module.exports = __webpack_public_path__ + "img/full5-min.7bd6b260.png";